import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Size } from '../../services/size';
import { LoadService } from '../../services/application/load.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/lib/ariadna/alert/alert.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    @ViewChild('ContentBlocAuth') contentBlocAuthEL: ElementRef | undefined;

    selectM = 0; // 0-Авторизация, 1- Регистрация, 2- Восстановление 3-Регистрация через телефон
    selectMenuStr = 'auth'; // auth-Авторизация, reg- Регистрация, recovery - Восстановление
    errText: string | null = null; // Текст ошибки
    private _setting: any;
    AccessReg = false; // Доступ к регистрации
    AuthFormText = 'Личный кабинет'; //
    message?: string;
    isMobile: boolean = false;
    resizeListener!: () => void;

    constructor(
        private size: Size,
        private title: Title,
        private load: LoadService,
        private router: Router,
        private route: ActivatedRoute,
        private alertService: AlertService
    ) {
        this._setting = load.configData.pages.login;
        if (this._setting?.CreatePatient) {
            this.AccessReg = this._setting.CreatePatient == 1 ? true : false;
        }
        if (this._setting?.Auth_form_text) {
            this.AuthFormText = this._setting.Auth_form_text;
        }

        if (this._setting?.title) {
            this.title.setTitle(this._setting.title);
        } else {
            this.title.setTitle('Авторизация');
        }
    }

    redirectTo(uri: string) {
        this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
                this.router.navigate([uri]);
            });
    }
    ngOnInit(): void {
        if (location.pathname.indexOf('/recovery') > 0) {
            this.onChangeM(2);
        }
        if (!this.load.configLoaded) {
            this.redirectTo('/503');
        }
        this.errText = '';
        const recoveryMessage = sessionStorage.getItem('recoveryMessage');
        if (recoveryMessage) {
            this.alertService.info(
                'Вам на почту отправлена ссылка для восстанавления пароля.',
                9000,
                true
            );
            sessionStorage.removeItem('recoveryMessage');
        }

        this.isMobile = window.innerWidth < 768;

        // Подписываемся на изменение размера окна
        this.resizeListener = () => {
            this.isMobile = window.innerWidth < 768;
        };
        window.addEventListener('resize', this.resizeListener);
    }

    ngAfterViewInit() {}

    ngOnDestroy(): void {
        window.removeEventListener('resize', this.resizeListener);
    }

    onChangeM(event: number) {
        this.errText = '';
        this.message = undefined;
        this.selectM = event;
        switch (event) {
            case 0: {
                this.selectMenuStr = 'auth';
                break;
            }
            case 1: {
                this.selectMenuStr = 'reg';
                break;
            }
            case 2: {
                this.selectMenuStr = 'recovery';
                this.router.navigate(['/login/recovery']);
                break;
            }
            default: {
                this.selectMenuStr = 'auth';
                break;
            }
        }
    }

    // Обработка ошибки
    onError(event: string) {
        this.errText = event;
    }

    // Обработка успоешной регистрации
    onRegSuccess(event: string) {
        this.message = event;
        this.selectMenuStr = 'auth';
        this.selectM = 0;
    }

    // Обработка успоешной авторизации
    onLoginSuccess(event: string) {
        this.message = event;
    }
    handleEnterKey(event: Event) {
        const key = event as KeyboardEvent;
        // Проверяем, что событие происходит из input
        const target = event.target as HTMLInputElement;

        // Если нажат Enter
        if (key.key === 'Enter') {
            // Предотвращаем стандартное поведение
            event.preventDefault();

            // Для компонента auth
            if (this.selectM === 0) {
                // Логика для компонента авторизации
                const authComponent = document.querySelector('app-auth');
                if (authComponent) {
                    const inputs = authComponent.querySelectorAll('input');
                    const currentIndex = Array.from(inputs).indexOf(target);

                    if (currentIndex < inputs.length - 1) {
                        // Переход к следующему полю
                        (inputs[currentIndex + 1] as HTMLInputElement).focus();
                    } else {
                        // Последнее поле - submit
                        this.submitAuth();
                    }
                }
            }

            // Аналогично для других компонентов при необходимости
        }
    }

    submitAuth() {
        // Метод для программного submit формы авторизации
        const authComponent = document.querySelector('app-auth');
        if (authComponent) {
            const submitButton = authComponent.querySelector(
                'button[type="submit"]'
            );
            if (submitButton) {
                (submitButton as HTMLButtonElement).click();
            }
        }
    }
}
